module.exports = __webpack_public_path__ + "img/writeIcon.caaabcad.png";